import { create } from 'zustand';
import type { ContentDocument, ProcessingStatus } from '../types/content';

interface ContentStore {
  uploadingFile: File | null;
  uploadProgress: number;
  currentContentId: string | null;
  processingStatus: ProcessingStatus | null;
  processingDocument: ContentDocument | null;
  userContent: ContentDocument[];

  setUploadingFile: (file: File | null) => void;
  setUploadProgress: (progress: number) => void;
  setCurrentContentId: (id: string | null) => void;
  setProcessingStatus: (status: ProcessingStatus | null) => void;
  setProcessingDocument: (doc: ContentDocument | null) => void;
  setUserContent: (content: ContentDocument[]) => void;
  reset: () => void;
}

export const useContentStore = create<ContentStore>((set) => ({
  uploadingFile: null,
  uploadProgress: 0,
  currentContentId: null,
  processingStatus: null,
  processingDocument: null,
  userContent: [],

  setUploadingFile: (file) => set({ uploadingFile: file }),
  setUploadProgress: (progress) => set({ uploadProgress: progress }),
  setCurrentContentId: (id) => set({ currentContentId: id }),
  setProcessingStatus: (status) => set({ processingStatus: status }),
  setProcessingDocument: (doc) => set({ processingDocument: doc }),
  setUserContent: (content) => set({ userContent: content }),
  reset: () => set({
    uploadingFile: null,
    uploadProgress: 0,
    currentContentId: null,
    processingStatus: null,
    processingDocument: null,
  }),
}));
